import { gql } from '@apollo/client';

const MIGRATE_AI_BEAT_FINAL_PATHS = gql`
  mutation migrateAiBeatFinalPaths($input: MigrateAiDataInput!) {
    migrateAiBeatFinalPaths(input: $input) {
      isSuccess
      message
    }
  }
`;

export default MIGRATE_AI_BEAT_FINAL_PATHS;
